(function () {
    var manageAlerts = {
        init: function () {
            manageAlerts.addTocAlertDialogHandlers();
            $('#jmodal-az-layer ul li a').on('click', manageAlerts.journalLinksClickHandler);
            manageAlerts.updateDialogwhenPageLoaded();
            manageAlerts.showHiddenPartsInPbEditMode();
            manageAlerts.initTocPbToolSelectAll();
        },
        addTocAlertDialogHandlers: function () {
            var registerAlerts = $('#registerAlerts');
            var showAlertDialog, hideAlertDialog;

            if (registerAlerts.length < 1) {
                return;
            }
            showAlertDialog = registerAlerts.find('#showAlertDialog');
            if (showAlertDialog !== 'undefined' && showAlertDialog.length > 0) {
                $(showAlertDialog).on('click', function (event) {
                    event.preventDefault();
                    $('.journalsModalWrap').removeClass('hidden');
                    $('#jmodal-az-layer').removeClass('hidden');
                    $('.topical-alerts-container').addClass('hidden');
                });
            }
            hideAlertDialog = registerAlerts.find('#jmodal-close_btn');
            if (hideAlertDialog !== 'undefined' && hideAlertDialog.length > 0) {
                $(hideAlertDialog).on('click', function (event) {
                    manageAlerts.closeAlertsDialog(event);
                });
            }
        },
        closeAlertsDialog: function (event) {
            event.preventDefault();
            $('.journalsModalWrap').addClass('hidden');
        },
        updateDialogwhenPageLoaded: function () {
            $("#jmodal-az-layer ul li input[type='checkbox']:checked").each(function () {
                var $aelem = $(this).closest('li').find('a');
                var id, selectedJournalCode, $topicalJournalCode;
                if ($aelem.length === 0) {
                    return true;
                }
                if (!$aelem.parents('.journal-added').length) {
                    $aelem.wrap("<div class='journal-added'></div>");
                }
                id = $aelem.prop('id');
                selectedJournalCode = id.substring('journal-'.length, id.length);
                $topicalJournalCode = $('.browse-taxonomies-container .journalCode');
                if ($topicalJournalCode.length === 0 || selectedJournalCode !== $topicalJournalCode.val()) {
                    $aelem.addClass('not-allowed-link');
                    $aelem.unbind('click');
                    $aelem.attr(
                        'title',
                        "To remove an e-Alert, uncheck the Issue Alerts box and set Article Alerts to 'Never'"
                    );
                }
            });
        },
        journalLinksClickHandler: function (event) {
            var journalCode = $(this).attr('id').replace('journal-', '');
            var journalCheckbox = $(this).closest('li').find("input[type='checkbox']").eq(0);
            var journalCategoryID = journalCheckbox.val();
            var isAopAlertDisabled = $(this).closest('li').hasClass('aop-ja-disabled');
            var excludedJournalCodes = $('#journalCodes').val();
            var showTocCheckbox = true;
            var i;
            var $widgetWrapper = $(this).parents('.journalsModalWrap');
            var $topicalAlertsJourCode = $widgetWrapper.find('.journalCode');
            var $widgetContainer = $(this).parents('.manageAlertsWidget');
            var $iipDefaultFrequencyInput = $widgetContainer.find('.iip-default-frequency');
            var iipDefaultFreq = $iipDefaultFrequencyInput.length > 0 ? $iipDefaultFrequencyInput.val() : 'D';
            var $allJoursWrapper;
            var $omegaWrapper;
            var toc = '';
            var asapIIP = '';
            var showSelectButtonClass = '';
            var domtoappend;
            var $topcalAlertRow;

            if (excludedJournalCodes !== '') {
                excludedJournalCodes = excludedJournalCodes.split(',');
                for (i = 0; i < excludedJournalCodes.length; i++) {
                    if (excludedJournalCodes[i] === journalCode) {
                        showTocCheckbox = false;
                    }
                }
            }

            if (
                $topicalAlertsJourCode.length !== 0 &&
                journalCode === $topicalAlertsJourCode.val() &&
                $widgetContainer.find('#enableTaxonomyPanel').val() === 'true'
            ) {
                $allJoursWrapper = $(this).parents('#jmodal-az-layer');
                if ($allJoursWrapper.length > 0) {
                    $allJoursWrapper.addClass('hidden');
                }
                if ($widgetContainer.length > 0) {
                    $omegaWrapper = $widgetContainer.find('.topical-alerts-container');
                    if ($omegaWrapper.length > 0) {
                        $omegaWrapper.removeClass('hidden');
                    }
                }
                // This journal is topical, so do not add it as normal journal alert, and show Topical Alerts Window.
                return;
            }
            if ($(this).parents('.journal-added').length === 0) {
                console.log($(this).attr('id').replace('journal-', ''));
                $(this).wrap("<div class='journal-added'></div>");
                //update hidden checkbox that will submit to server.
                journalCheckbox.prop('checked', 'true');

                console.log('journalCategoryID : ' + journalCategoryID);
                if (showTocCheckbox) {
                    toc =
                        '<input type="checkbox" id="toc-' +
                        $(this).attr('id').replace('journal-', '') +
                        '" class="checkbox" checked="checked" value="true"  name="toc-' +
                        journalCategoryID +
                        '">';

                    if (isAopAlertDisabled) {
                        showSelectButtonClass = 'hide';
                    }
                    asapIIP =
                        '<select id="toc-asap-' +
                        $(this).attr('id').replace('journal-', '') +
                        '" class="dropDownList ' +
                        showSelectButtonClass +
                        '" name="toc-asap-iip-' +
                        journalCategoryID +
                        '">' +
                        '<option value="N" selected="">Never</option>' +
                        '<option value="D">Daily</option>' +
                        '<option value="W">Weekly</option>' +
                        '<option value="M">Monthly</option>' +
                        '</select>';
                } else {
                    toc =
                        '<input type="checkbox" id="toc-' +
                        $(this).attr('id').replace('journal-', '') +
                        '" class="checkbox hide"  value="false"  name="toc-' +
                        journalCategoryID +
                        '"  disabled>';
                    showSelectButtonClass = '';
                    if (isAopAlertDisabled) {
                        showSelectButtonClass = 'hide';
                    }
                    asapIIP =
                        '<select id="toc-asap-' +
                        $(this).attr('id').replace('journal-', '') +
                        '" class="dropDownList ' +
                        showSelectButtonClass +
                        '" name="toc-asap-iip-' +
                        journalCategoryID +
                        '">' +
                        '    <option value="N" ' +
                        (iipDefaultFreq === 'N' ? 'selected' : '') +
                        '>Never</option>' +
                        '    <option value="D" ' +
                        (iipDefaultFreq === 'D' ? 'selected' : '') +
                        '>Daily</option>' +
                        '    <option value="W" ' +
                        (iipDefaultFreq === 'W' ? 'selected' : '') +
                        '>Weekly</option>' +
                        '    <option value="M" ' +
                        (iipDefaultFreq === 'M' ? 'selected' : '') +
                        '>Monthly</option>' +
                        '</select>';
                }
                domtoappend =
                    '<tr id="added-journal-' +
                    journalCode +
                    '">' +
                    '<td class="rowText journalTitle">' +
                    $(this).text() +
                    '</td>' +
                    '<td class="rowText">' +
                    '<div class="settingInput"><span>Issue alerts:</span>' +
                    toc +
                    '</div>' +
                    '</td>' +
                    '<td class="rowText">' +
                    '<div class="settingInput"><span>Article alerts:</span>' +
                    asapIIP +
                    '</div>' +
                    '</td>' +
                    '</tr>';
                $topcalAlertRow = $('#journalsAlertsTable').find('tr.topical_alert:first');
                if ($topcalAlertRow.length > 0) {
                    $topcalAlertRow.before(domtoappend);
                } else {
                    $('#journalsAlertsTable > tbody').append(domtoappend);
                }
            } else {
                //remove the journal from the list
                console.log('remove:' + $(this).attr('id').replace('journal-', ''));
                $(this).unwrap();
                $('#added-journal-' + journalCode).remove();
                //update hidden checkbox that will submit to server.
                journalCheckbox.removeAttr('checked');
            }
            if ($('#journalsAlertsTable > tbody').children().length > 1) {
                //hide the no journal row
                if ($('#nojournals:visible')) {
                    $('#nojournals').hide();
                }
            } else {
                if ($('#nojournals:hidden')) {
                    $('#nojournals').show();
                }
            }
            manageAlerts.closeAlertsDialog(event);
        },
        showHiddenPartsInPbEditMode: function () {
            var $journalsWrap = $('.journalsModalWrap.all-journals');
            var $journalsCodes = $journalsWrap.find('#jmodal-az-layer');
            var $omegaFilters = $journalsWrap.find('.topical-alerts-container');
            var $allJournalsSection = $('.journalsModalWrap .journalsModal');

            if ($('html').attr('id') !== 'pb-editor') {
                return;
            }

            if ($journalsWrap.length === 0) {
                return;
            }
            $journalsWrap.removeClass('hidden');
            $journalsWrap.css('position', 'relative');
            $journalsWrap.css('z-index', 'auto');

            $journalsCodes.removeClass('hidden');

            $omegaFilters.removeClass('hidden');

            $allJournalsSection.css('position', 'relative');
            $allJournalsSection.css('height', 'auto');
        },

        initTocPbToolSelectAll: function () {
            var $all_checkboxes = $('.publications-list').find("input[name='doi']:checkbox");
            var $checkedCheckboxes;

            if ($('.selectAll').length > 0) {
                $('.selectAll').prop('checked', false);

                $('.selectAll').on('click', function () {
                    $all_checkboxes.prop('checked', $(this).is(':checked'));
                });

                $('.publications-list')
                    .find("input[name='doi']:checkbox")
                    .on('change', function () {
                        $checkedCheckboxes = $all_checkboxes.filter(':checked');
                        if ($checkedCheckboxes.length < $all_checkboxes.length) {
                            $('.selectAll').prop('checked', false);
                        } else if ($checkedCheckboxes.length === $all_checkboxes.length) {
                            $('.selectAll').prop('checked', true);
                        }
                    });
            }
        },

        submitArticles: function (anElement, action) {
            var aForm = $(anElement).closest('form');
            manageAlerts.submitMultiArticles(aForm, action, false);
        },

        submitMultiArticles: function (aForm, action, aMarkall, errorMessage) {
            var hasMarked = false;
            var elmts = $(aForm).find('input');
            var i;

            for (i = 0; i < elmts.length; i++) {
                if (elmts[i].name === 'doi' && elmts[i].type === 'checkbox' && elmts[i].checked) {
                    hasMarked = true;
                    break;
                }
            }

            if (!hasMarked) {
                if (aMarkall) {
                    manageAlerts.markAllCheckboxes(aForm, 'doi', true);
                } else {
                    alert(errorMessage ? errorMessage : 'Please check at least one article.');
                    return false;
                }
            }

            for (i = 0; i < elmts.length; i++) {
                if (elmts[i].name === 'doi' && elmts[i].type !== 'checkbox') {
                    elmts[i].name = 'xdoi';
                }
            }

            if (aForm.attr('action') == null) {
                aForm.action = action;
            } else {
                aForm.attr('action', action);
            }
            aForm.attr('method', 'post');
            aForm.submit();
            return true;
        },

        /**	marks all check box */
        markAllCheckboxes: function (aForm, aNamePrefix, aChecked) {
            var elmts;
            var i;

            if (aForm && aForm.length > 0 && aForm[0].tagName && aForm[0].tagName === 'FORM') {
                aForm = aForm[0];
            }

            elmts = $(aForm).find('input');

            for (i = 0; i < elmts.length; i++) {
                if (elmts[i].type === 'checkbox' && elmts[i].name.indexOf(aNamePrefix) === 0) {
                    elmts[i].checked = aChecked;
                }
            }
        },
    };
    UX.manageAlerts = manageAlerts;
})();
